module.exports = __webpack_public_path__ + "static/media/NanumSquareL.fa926963.woff";